export type MeaningfulDraftFields = {
  messageText?: string | undefined
  quotedEventId?: number | undefined
  files?: unknown[] | undefined
}

/** Draft counts as activity only with text, quote or files. */
export const isMeaningfulDraft = (
  draft?: MeaningfulDraftFields | null,
): boolean => Boolean(
  draft?.messageText?.trim()
  || draft?.quotedEventId
  || draft?.files?.length,
)
